import PropTypes from 'prop-types';
import classNames from 'classnames';

import { trans } from '@spotahome/soyuz/client';

import {
  usePricingContext,
  useDisplayListingPricing
} from '../context/PricingContext';

import RentableUnitPriceOffer from './RentableUnitPriceOffer';

import './RentableUnitPrice.scss';

const RentableUnitPrice = ({ showPrice = true, isSmallerRate = false }) => {
  const { priceRange, isMonthlyPrice, pricingDetails } = usePricingContext();
  const displayPricing = useDisplayListingPricing();

  const perMonthClasses = classNames('rentable-unit-price__per-month', {
    'rentable-unit-price__per-month-smaller': isSmallerRate
  });

  if (!showPrice) {
    return (
      <span className="rentable-unit-price__hint">
        {trans('search.hide-prices-until-dates')}
      </span>
    );
  }

  if (pricingDetails?.hasOffer) {
    return <RentableUnitPriceOffer {...displayPricing} />;
  }

  const { price } = displayPricing;

  return (
    <span className="rentable-unit-price">
      {!priceRange.isSeasonalPriceFeatureOn &&
        isMonthlyPrice &&
        `${trans('rentable_unit_price.label.from')} `}
      <span className="rentable-unit-price__number">{price}</span>
      <span className={perMonthClasses}>
        {' '}
        {trans('property_show.book_now_card.per_month')}
      </span>
    </span>
  );
};

RentableUnitPrice.propTypes = {
  showPrice: PropTypes.bool,
  isSmallerRate: PropTypes.bool
};

export default RentableUnitPrice;
